module.exports = __webpack_public_path__ + "img/tim.32c81493.png";